RFM_APP.controller("formSearchController", ["$scope", "$http", "$timeout", "$location", "helper", "$state", "requestMilesService",  function ($scope, $http, $timeout, $location, helper, $state, requestMilesService) {
    requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Start");
    var preFormData = $j("#formSearchController").attr("initial-formData");
    var landingPageUrl = "/forms/request-flight-miles";
    var showModifyByClick = false;
    var $errorMessage = $j(".genericServerError");
    var errorPage = "/error/system-trouble";
    $scope.flights = null;
    var init = function () {
        if (preFormData !== "") {
            $scope.form = JSON.parse(preFormData);
            requestMilesService.setLabels($scope.form.labels);
        }
        helper.updatePageTitle("pageTitle_landing_rfm");
        $scope.emailChanged = false;
        $timeout(function () {
            $j("html,body").scrollTop(0);
        },0);
    };
    var errorHandler = function (jqXHR) {
        helper.errorHandler(jqXHR, $errorMessage, errorPage);
    };
    $scope.cabinTypes = [
        {"key": "message.cabin.mainCabin", "name": AAcom.prototype.getProperty("mainCabin_rfm")},
        {"key": "message.cabin.businessFirst", "name": AAcom.prototype.getProperty("businessFirst_message_rfm")}
    ];
    $scope.form = {};
    $scope.saved = false;
    $scope.thanks = false;
    $scope.disabled = false;
    $scope.selectedFlights = {};
    $scope.toggleFlightSelection = function(flight) {
	    var selectedFlight = $scope.selectedFlights[flight.flightNumber];
	    if (typeof selectedFlight === 'undefined') {
	    	$scope.selectedFlights[flight.flightNumber] = flight;
	    }else {
	    	delete $scope.selectedFlights[flight.flightNumber];
	    }
    };
    $scope.populateManualJetSmart = function () {
        delete $scope.form["errors"];
        delete $scope.form["errorKeys"];
        $j(".genericServerError").hide();
        $scope.form.requestMilesInfo.jetSmartFlag = true;
        requestMilesService.searchFlightDetails({requestMilesInfo : $scope.form.requestMilesInfo}).then(
           		function(response){
                    requestMilesService.clearPageErrorCodes();
                    $state.go('long');
           		}, function(error){
           			helper.errorHandler(error, $errorMessage, errorPage);
           		});
    }
    $scope.populateManual = function () {
    	 delete $scope.form["errors"];
         delete $scope.form["errorKeys"];
         $j(".genericServerError").hide();
         requestMilesService.searchFlightDetails({requestMilesInfo : $scope.form.requestMilesInfo}).then(
    		function(response){
    		    if(typeof response.data.errorSummaryMessage !== 'undefined'){
                    // show error message
                    $scope.form.errors = response.data;
                    if(response.data.requestMilesInfo.aadvantageNumberCode != undefined  &&
                    		(response.data.requestMilesInfo.aadvantageNumberCode === 'ERRCODE1430')) {
                    	$scope.form.requestMilesInfo.populateManualFirstTime = false;
	                    response.data.requestMilesInfo.aadvantageNumber = ' ';
	                    response.data.requestMilesInfo.eticketNumber = ' ';
	                    requestMilesService.pushPageErrorCode(response.data.requestMilesInfo.aadvantageNumberCode);
	                    requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Start");
                   	    requestMilesService.addToWebAnalytics("error_id", requestMilesService.getPageErrorCodes());
	                    requestMilesService.reportToWebAnalytics();
                    } else if(response.data.requestMilesInfo.aadvantageNumberCode != undefined &&
                    		response.data.requestMilesInfo.aadvantageNumberCode === 'ERRCODE1477' ||
                    		response.data.requestMilesInfo.aadvantageNumberCode === 'ERRCODE1429' ||
                    		response.data.requestMilesInfo.aadvantageNumberCode === 'ERRCODE1478' ||
                            response.data.requestMilesInfo.aadvantageNumberCode === 'ERRCODE1915' ||
                			response.data.requestMilesInfo.aadvantageNumberCode === 'ERRCODE1479') {
                    	requestMilesService.setMessageCodeForConfirmationPage(response.data.requestMilesInfo.aadvantageNumberCode);
                    	requestMilesService.setSameUser(response.data.isSameUser);
                    	$state.go('request-submitted');
                    } else if(response.data.requestMilesInfo.aadvantageNumberCode != undefined &&
                    		(response.data.requestMilesInfo.aadvantageNumberCode === 'ERRCODE858')) {
	                    response.data.requestMilesInfo.aadvantageNumber = '';
                        requestMilesService.pushPageErrorCode(response.data.requestMilesInfo.aadvantageNumberCode);
                        requestMilesService.addToWebAnalytics("error_id", requestMilesService.getPageErrorCodes());
						requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Start");
	                    requestMilesService.reportToWebAnalytics();
                    $timeout(function() {
                            helper.scrollToErrorSummary($j("#errorSummary"));
                        }, 0);
                    } else {
                    	$scope.form.errorKeys = requestMilesService.doSorting(response.data.requestMilesInfo, $scope.form.requestMilesInfoSortedlabels);
                    	 requestMilesService.addToWebAnalytics("error_id", requestMilesService.getPageErrorCodes());
						 requestMilesService.addToWebAnalytics("page_name", "Request Flight Miles-Start");
                         requestMilesService.reportToWebAnalytics();
                         $timeout(function() {
                             helper.scrollToErrorSummary($j("#errorSummary"));
                         }, 0);
                    }
                }else{
					if(response.status == 202) {
    					// navigate to travelinfo
					    requestMilesService.clearPageErrorCodes();
    					$state.go('long');
    				} else {
    					requestMilesService.populateAirlinesData(response.data);
    				    requestMilesService.clearPageErrorCodes();
    					$state.go('request-submitted');
    				}
                }
    		}, function(error){
    			helper.errorHandler(error, $errorMessage, errorPage);
    		});
    }
    $scope.doFocus = function(attr) {
        $timeout(function () {
            angular.element('#' + attr).focus();
        },0);
    }
    $scope.isNumber = function (event) {
        helper.isNumber(event);
    };
    requestMilesService.overrideSkipLinks();
    init();
}]);
